var lx = lx || {};
var vRptID, vRptCode, vRptParams, vRptTabPopup, vRptFilename, vRptType, vRptTitlename, vRptConfirm, vRptLangId = '';
var vRptRun = 'Yes';
lx.report = {
    run: function (pRptCode,pRptParams,pRptType,pRptTabPopup,pRptFilename,pRptTitlename) {
		vRptLangId = $v("P333_LANGUAGE");
		vRptCode = pRptCode;
		if (pRptType == undefined) {
			lx.report.get(pRptCode);
		}
		else {
			vRptParams = pRptParams;
			vRptType = pRptType;
		}
		if(pRptFilename !== undefined) {
			vRptFilename = pRptFilename;
		}
		if(pRptTitlename !== undefined) {
			vRptTitlename = pRptTitlename;
		}
		if(pRptTabPopup !== undefined) {
			vRptTabPopup = pRptTabPopup;
		}
		if (vRptRun == 'Yes') {
			apex.server.process("reportRun", {
				x01: vRptCode,
				x02: vRptParams,
				x03: vRptType,
				x04: vRptFilename,
				x05: vRptTitlename,
				x06: vRptLangId
			}, {
				dataType: "text",
				success: function (d) {
					if (vRptType == 'pdf' || vRptType == 'doc' || vRptType == 'xls') {
						console.log("1-"+vRptType+"="+d);
						if (vRptTabPopup == 'TAB') {
							window.open(d);
						}
						if (vRptTabPopup == 'POPUP') {
							lx.util.popup(d, 960, 600);
						}
					}
					if (vRptType == 'gen') {
						lx.load.add();
						console.log("2-"+vRptType+"="+d);
						//window.location.href = d;
						
						/*start*/
						var req = new XMLHttpRequest();
						req.open("GET", d, true);
						req.responseType = "blob";
						req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

						var fileName = vRptFilename;

						req.onload = function (event) {
							var blob = req.response;

							if (req.status === 200) {
								var link = document.createElement('a');

								link.href = window.URL.createObjectURL(blob);
								link.download = fileName;
								link.click();

								//call your method her to do anything
								lx.load.remove();
							}
						};

						req.send();
						
						
						/*end*/
					}
				}
			});
		}
		else if (vRptRun !== 'Yes') {
			alert(vRptRun);
		}
		
	},
    run2: function (pRcode, pParams, pType, pFilename, pRtype, pTitlename) {
		var day = new Date;
		if (pRtype == 'pdf') {
			$.ajax({
				url: "wwv_flow.show",
				dataType: "html",
				traditional: true,
				cache: false,
				type: "POST",
				data: {
					p_flow_id: $v("pFlowId"),
					p_flow_step_id: $v("pFlowStepId"),
					p_instance: $v("pInstance"),
					p_request: "APPLICATION_PROCESS=reportRun",
					x01: pRcode,
					x02: pParams,
					x03: pRtype,
					x04: pFilename,
					x05: pTitlename
				},
				success: function (d) {
					if (pType == 'TAB') {
						window.open(d);
					}
					if (pType == 'POPUP') {
						popUp2(d, 960, 600);
					}
				}
			});
		}
		if (pRtype == 'gen') {
			pageLink(235, 'P235_RCODE,P235_PAR,P235_RTYPE', pRcode + "," + pParams + "," + pRtype, function cb(res) {
				if (res.indexOf("f?p") == 0) {
					eval(lx.util.popup(res, 500, 200));
				}
				else {
					eval(res);
				}
			});
		}
	},
	checkRun: function (pRptCode) {
		apex.message.clearErrors();
		lx.report.get(pRptCode);
		apex.server.process("checkRun", {
			x01: pRptCode,
			x02: vRptParams
		}, {
			dataType: "json",
			success: function (ret) {
				//var vRet = ret.trim();
				console.log('ret.errors='+ret.errors);
				if (ret.errors.length > 0) {
					console.log('if');
					apex.message.showErrors(ret.errors);//lx.info.error(ret.errors);				
				}
				else {
					console.log('else');
					lx.report.run(pRptCode);	
				}
			}
		});
		
	},
    get: function (pRptCode) {
		var vCatalogType, vWarehouse, vMe, vReportType, vEmployee, vDateFormat, vTimeFormat, vDocType, vDateFrom, vDateTo, vOrganization, vYear, vEmploymentType, vDepartment, vType, vPaySts, vPartner, vDocAuthor, vProject, vWorkPosition, vCertificationType = '';
		//lx.report.getID(pRptCode);
		if (pRptCode == 'MEMBER_DECK') {
			vRptParams = $v('P333_PROFILE_ID') 									  		+ ":" +
						 lxnvl(getCheckedValuesByName('P333_CONTENT_103',','),'') 		+ ":" +
						 lxnvl($("#P333_ORDER_BY_103").val(),'') 						+ ":" +
						 lxnvl($v("P333_MEMBERSHIP_TYPE_103_HIDDENVALUE"),'') 		    + ":" +
						 lxnvl($("#P333_WORK_POSITION_103").val(),'') 					+ ":" +
						 lxnvl($v("P333_MEMBER_NAME_103_HIDDENVALUE"),'') 				+ ":" +
						 lxnvl($v("P333_CERTIFICATION_TYPE_103_HIDDENVALUE"),'') 		+ ":" +
						 lxnvl($("#P333_CERTIFICATION_STATUS_103").val(),'') 			+ ":" +
						 lxnvl($("#P333_MEMBER_TYPE_103").val(),'') 					+ ":::";
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = '';
		}
		else if (pRptCode == 'EMPLOYEE_DECK') {
			vRptParams = 	$v('P333_PROFILE_ID') 										+ ":" +
							lxnvl($v("P333_DEPARTMENT_404_HIDDENVALUE"),'') 			+ ":" +
							lxnvl($("#P333_WORK_POSITION_404").val(),'') 				+ ":" +
							lxnvl($v("P333_CERTIFICATION_TYPE_404_HIDDENVALUE"),'') 	+ ":" +
							lxnvl('A','') 												+ ":" +
							getCheckedValuesByName('P333_REPORT_TYPE_404',',') 			+ ":" +
							$("#P333_CERTIFICATION_STATUS_404").val() 					+ ":" +
							$("#P333_ORDER_BY_404").val() 								+ ":" +
							lxnvl($v("P333_EMPLOYEE_NAME_404_HIDDENVALUE"),'') 			+ ":" +
							lxnvl($v("P333_EMPLOYMENT_TYPE_404_HIDDENVALUE"),'')		+ ":::";
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = '';
		}
		else if (pRptCode == 'ITEM_CATALOG') {
			vCatalogType = document.getElementById('P333_CATALOG_TYPE_864').value;
			if (vCatalogType == 'I') {
				vRptCode = 'TRACKING_ITEMS';
				vRptParams = 	$v('P333_PROFILE_ID') 									+ "~" + 
								$v("P333_REPORT_TYPE_864") 								+ "~" + 
								document.getElementById('P333_OBJECT_TYPE_864').value 	+ "~";
			}
			else {
				vWarehouse = document.getElementById('P333_WAREHOUSE_864').value;  
				if (vCatalogType != 'P'){vWarehouse = '';}
				vRptParams = 	$v('P333_PROFILE_ID') 								+ "~" +
								document.getElementById('P333_CATEGORY_864').value 	+ "~" +
								vCatalogType 										+ "~" +
								$("#P333_DISPLAY_864").select2("val") 				+ "~" +
								$v("P333_PRICE_864") 								+ "~" +
								$v("P333_QUANTITY_864") 							+ "~" +
								vWarehouse 											+ "~" +
								$v("P333_DESCRIPTION_864") 							+ "~";
			}
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = '';
		}
		else if (pRptCode == 'HR_ANALYTICS') {
			vRptParams = 	document.getElementById('P333_DOCUMENT_TYPE_764').value + "~" +
							document.getElementById('P333_DATE_FROM_764').value + "~" +
							document.getElementById('P333_DATE_TO_764').value + "~" +
							document.getElementById('P333_EMPLOYEE_764').value + "~" +
							document.getElementById('P333_ORGANIZATION_764').value + "~" +
							$v('P333_TIME_FORMAT_764') + "~";
			if ($v('P333_DATE_FROM_764')=='') {  
				if ($v('P333_DATE_TO_764')!=='') {  
					vRptRun = 'Please either enter both dates or leave both fields empty.';
				}
			}        
			if ($v('P333_DATE_FROM_764')!=='') {  
				if ($v('P333_DATE_TO_764')=='') {  
					vRptRun = 'Please either enter both dates or leave both fields empty.';
				}
			} 
			if (lx.util.stringToDate($v('P333_DATE_FROM_764'),"dd.MM.yyyy",".") > lx.util.stringToDate($v('P333_DATE_TO_764'),"dd.MM.yyyy",".")) {
				vRptRun = 'This is not a valid period. Please check dates entered.';
			}
			if (vRptRun=='') {
				vRptRun = 'Yes';
			}
			vRptType = 'gen';
		}
		else if (pRptCode == 'HR_ANALYTICS_PER_EMP') {
			vMe = document.getElementById('P333_ME').value;
			vEmploymentType = '';
			vOrganization = '';
			if (vMe == 'Y') {
				vEmployee = document.getElementById('P333_EMPLOYEE_ME_1524').value;
			}
			else {
				vEmployee = document.getElementById('P333_EMPLOYEE_1524').value;
				vEmploymentType = document.getElementById('P333_EMPLOYMENT_TYPE_1524').value;
			}
			if (vMe == 'N') {
			  vOrganization = document.getElementById('P333_ORGANIZATION_1524').value;
			}
			vRptParams = 	document.getElementById('P333_DOCUMENT_TYPE_1524').value + "~" +
							document.getElementById('P333_DATE_FROM_1524').value + "~"+
							document.getElementById('P333_DATE_TO_1524').value + "~" +
							vEmployee + "~" +
							vOrganization + "~" +
							document.getElementById('P333_YEAR_1524').value + "~~" +
							$v('P333_TIME_FORMAT_1524') + "~" +
							vEmploymentType + "~~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'HR_ANALYTICS_PER_DOC') {
			vRptParams = 	document.getElementById('P333_DOCUMENT_TYPE_1544').value + "~" +
							document.getElementById('P333_DATE_FROM_1544').value + "~"+
							document.getElementById('P333_DATE_TO_1544').value + "~" +
							document.getElementById('P333_EMPLOYEE_1544').value + "~" +
							document.getElementById('P333_ORGANIZATION_1544').value + "~" +
							document.getElementById('P333_YEAR_1544').value + "~~" +
							$v('P333_TIME_FORMAT_1544') + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'HR_ACTIVITIES') {
			vDepartment = document.getElementById('P333_ORGANIZATION_824').value;
			if (vDepartment == 0) vDepartment = '';
			vWorkPosition = document.getElementById('P333_WORK_POSITION_824').value;
			if (vWorkPosition == 0) vWorkPosition = '';
			vType = $("#P333_TYPE_824").select2("val");
			if (vType==undefined){vType='';}
			vRptParams = 	$v('P333_PROFILE_ID') + "~" +
							vDepartment + "~" +
							vWorkPosition + "~" +
							document.getElementById('P333_EMPLOYEE_824').value + "~" +
							$("#P333_DOCUMENT_TYPE_824").select2("val") + "~" +
							vType + "~M~" +
							document.getElementById('P333_DATE_FROM_824').value + "~" +
							document.getElementById('P333_DATE_TO_824').value + "~" +
							$("#P333_STATUS_824").select2("val") + "~";
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = document.getElementById('P333_REPORT_NAME').value;		
		}
		else if (pRptCode == 'CDO_OVERVIEW') {
			vType = document.getElementById('P333_DOCUMENT_TYPE_CODE').value;
			if (vType !== '') {
			   vDocType = document.getElementById('P333_DOCUMENT_TYPE_ID').value;
			   if (vType == 'INV' || vType == 'RCT') {
				 vPaySts = document.getElementById('P333_PAYMENT_STATUS').value;
				 if (typeof vPaySts === 'undefined') {
					vPaySts = null;
				 }
			   }
			}
			else {
				vDocType = document.getElementById('P333_DOCUMENT_TYPE_884').value;
			}
			vOrganization = '';
			if (vType=='NNA' || vType == ''){
				vOrganization = document.getElementById('P333_ORG_UNIT_ID_884').value;
			}			
			vRptParams = 	$v('P333_PROFILE_ID') + "~" +
							document.getElementById('P333_DATE_FROM_884').value + "~" +
							document.getElementById('P333_DATE_TO_884').value + "~" +
							vDocType + "~" +
							document.getElementById('P333_PARTNERS_884').value + "~" +
							document.getElementById('P333_EMPLOYEE_884').value + "~" +
							document.getElementById('P333_PROJECT_884').value + "~" +
							vOrganization + "~" +
							document.getElementById('P333_CATALOG_ID_884').value + "~" +
							vType + "~" +
							(vPaySts?vPaySts:'') + "~" +
							document.getElementById('P333_DOCUMENT_SUBTYPE_884').value + "~" +
							document.getElementById('P333_TASK_884').value + "~";
			vRptType = 'gen';
			if ((vRptParams == $v('P333_PROFILE_ID') + "~~~~~~~~~~~" && vType == '') || (vRptParams == $v('P333_PROFILE_ID') + "~~~"+vDocType+"~~~~~~"+vType+"~"+vPaySts+"~" && vType !== '')) {
				vRptConfirm = confirm("Warning: It may take a while to create this report. If you want to run report press 'OK' , otherwise press 'Cancel'.");
				if (vRptConfirm == true) {
					vRptRun = 'Yes';
				} else {
					vRptRun = 'No';
				}
			}
		}
		else if (pRptCode == 'CDO_WHD_OVERVIEW') {
			var vReportType = $v('P333_REPORT_TYPE_544');
			if (vReportType == 'D') {
				vRptCode = 'CDO_WHD_OVERVIEW';
				vRptParams =	$v('P333_PROFILE_ID') + "~" +
								document.getElementById('P333_DATE_FROM_D_544').value 			+ "~" +
								document.getElementById('P333_DATE_TO_D_544').value 			+ "~" +
								document.getElementById('P333_DOCUMENT_TYPE_D_544').value 		+ "~" +								
								$v("P333_PARTNERS_D_544_HIDDENVALUE") 			                + "~" +
								$v("P333_EMPLOYEE_D_544_HIDDENVALUE") 			                + "~" +
								$v("P333_PROJECT_D_544_HIDDENVALUE") 			                + "~" +
								$v("P333_OBJECT_D_544_HIDDENVALUE") 				            + "~" +
								$v("P333_PROJECT_CATEGORY_D_544_HIDDENVALUE")	                + "~" +
								document.getElementById('P333_DOCUMENT_STATUS_D_544').value 	+ "~"
			}
			if (vReportType == 'A'){
				vRptCode = 'CDO_WHD_OVERVIEW_I';
				vRptParams = 	$v('P333_PROFILE_ID')										+ "~" +
								document.getElementById('P333_DATE_FROM_A_544').value 		+ "~" +
								document.getElementById('P333_DATE_TO_A_544').value 		+ "~" +
								document.getElementById('P333_CATALOG_ITEM_A_544').value	+ "~" +
								document.getElementById('P333_WAREHOUSE_A_544').value 		+ "~";
				var vItemReportType = $v('P333_ITEM_REPORTS_A_544');
				if (vItemReportType == 'I'){
					vRptCode = 'WH_ITEM_CHRONOLOGY';
				}
			}   
			if (vReportType == 'I'){
				vRptCode = 'WDT2';
				vRptParams = 	document.getElementById('P333_WAREHOUSE_I_544').value + "~~" +
								document.getElementById('P333_DATE_I_544').value + "~";
			}
			if (vReportType == 'A' && vItemReportType == 'I' && document.getElementById('P333_CATALOG_ITEM_A_544').value == '') {
				if (confirm(apex.lang.getMessage("ALL_CATALOG_ITEMS_OR_NOT"))) {
					vRptRun = 'Yes';
				}
						
			}
			else {
				var vRptRun = 'Yes'; 
				if (vRptCode == 'CDO_WHD_OVERVIEW' && vRptParams == $v('P333_PROFILE_ID') + "~~~~~~~~~~") {
					if (confirm("Warning: It may take a while to create this report. If you want to run report press 'OK' , otherwise press 'Cancel'.")) {
						vRptRun = 'Yes';
					} else {
						vRptRun = 'No';
					}
				}
			}
			vRptType = 'gen';
		}
		else if (pRptCode == 'EVENT_STATISTIC') {
			if ($v('P333_PUBLISHING_484') == 'B')
			{
				vRptCode = 'BID_STATISTIC';
				vRptParams = 	'APP_PROFILE_ID~' +
								document.getElementById('P333_DATE_FROM_'+$v('P333_PUBLISHING_484')+'_484').value + '~' +
								document.getElementById('P333_DATE_TO_'+$v('P333_PUBLISHING_484')+'_484').value + '~' +
								document.getElementById('P333_BID_TYPE_484').value + "~" +
								document.getElementById('P333_COUNTRY_CODE_484').value + '~';
			}
			if ($v('P333_PUBLISHING_484') == 'E')
			{				
				vRptCode = 'EVENT_STATISTIC';
				vRptParams = 	'APP_PROFILE_ID~' +
								document.getElementById('P333_DATE_FROM_'+$v('P333_PUBLISHING_484')+'_484').value + '~' +
								document.getElementById('P333_DATE_TO_'+$v('P333_PUBLISHING_484')+'_484').value + '~' +
								document.getElementById('P333_EVENT_TYPE_484').value + '~~~~' +
								$v('P333_TIME_FORMAT_484') + '~';
			}
			if ($v('P333_PUBLISHING_484') == 'J')
			{
				vRptCode = 'JOB_STATISTIC';
				vRptParams = 	'APP_PROFILE_ID~' + 
								document.getElementById('P333_DATE_FROM_'+$v('P333_PUBLISHING_484')+'_484').value + '~' +
								document.getElementById('P333_DATE_TO_'+$v('P333_PUBLISHING_484')+'_484').value + '~~' +
								document.getElementById('P333_INDUSTRY_TYPE_484').value + '~~';
			}
			var vRptRun = 'Yes'; 
			if (vRptParams == 'APP_PROFILE_ID~~~~~') {
				var r = confirm("Warning: It may take a while to create this report. If you want to run report press 'OK' , otherwise press 'Cancel'.");
				if (r == true) {
					vRptRun = 'Yes';
				} else {
					vRptRun = 'No';
				}
			}
			vRptType = 'gen';
			
		}
		else if (pRptCode == 'CERT_MATRIX') {
			vOrganization = lxnvl($("#P333_DEPARTMENT_984").val(),[]);
			vWorkPosition = lxnvl($("#P333_WORK_POSITION_984").val(),[]);
			vCertificationType = lxnvl($("#P333_CERTIFICATION_TYPE_984").val(),[]);
			vRptParams = 	"APP_PROFILE_ID~" +
							$v('P333_USER_TYPE_984') + "~" +
							lxnvl(vWorkPosition.join('_'),'') + "~" +
							lxnvl(vCertificationType.join('_'),'') + "~" +
							lxnvl(vOrganization.join('_'),'') + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'PROJECT_MANHRS_ALL') {
			vProject = '';
			if ($v('P333_EMPLOYEE_ID') == ''){
				vProject = document.getElementById('P333_PROJECT_ID_1104').value;
			}			
			vRptParams = 	vProject + "~" +
							$v('P333_EMPLOYEE_ID') + "~" +
							document.getElementById('P333_DATE_FROM_1104').value + "~" +
							document.getElementById('P333_DATE_TO_1104').value + "~" +
							$v('P333_REPORT_TYPE') + "~"; 
			vRptType = 'gen';
		}
		else if (pRptCode == 'PROJECT_ATT') {
			vRptParams = document.getElementById('P333_PROJECT_ID_1104').value + "~" +
						 document.getElementById('P333_DATE_FROM_1104').value + "~" +
						 document.getElementById('P333_DATE_TO_1104').value + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'WORK_IN_PROGRESS') {
			vRptParams = document.getElementById('P333_DATE_1064').value + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'MAINTAINED_ITEM_EXP' || pRptCode == 'PAYMENT_PROGRESS') {			
			vRptParams = 	document.getElementById('P333_MASTER_OBJECT_ID_1024').value + "~" +
							document.getElementById('P333_ITEMS_1024').value + "~" +
							document.getElementById('P333_DATE_FROM_1024').value + "~" +
							document.getElementById('P333_DATE_TO_1024').value + "~";
			if (document.getElementById('P333_DATE_FROM_1024').value=='' || document.getElementById('P333_DATE_TO_1024').value=='') {
				vRptRun = apex.lang.getMessage("PERIOD_ENTER");
			}
			else {
				vRptRun = 'Yes';
			}
			vRptType = 'gen';
		}
		else if (pRptCode == 'CONTACT_COMMENTS') {
			vDateFormat = '&APP_DATE_FORMAT.';
			var vStartDate2 = stringToDate($v('P333_START_DATE_1564'),vDateFormat,$v('P333_START_DATE_1564').match(/\D/));
			var vEndDate2 = stringToDate($v('P333_END_DATE_1564'),vDateFormat,$v('P333_END_DATE_1564').match(/\D/));
			vRptParams = 	"~" + 
							$v('P333_STATUS_1564') + "~" +
							document.getElementById('P333_LIST_ID_1564').value + "~" +
							document.getElementById('P333_MANAGER_1564').value + "~" +
							document.getElementById('P333_TAG_1564').value + "~" +
							document.getElementById('P333_START_DATE_1564').value + "~" +
							document.getElementById('P333_END_DATE_1564').value + "~";
			if ($v('P333_START_DATE_1564')=='') {  
				if ($v('P333_END_DATE_1564')!=='') {  
					vRptRun = 'Please either enter both dates or leave both fields empty.';
				}
			}        
			if ($v('P333_START_DATE_1564')!=='') {  
				if ($v('P333_END_DATE_1564')=='') {  
					vRptRun = 'Please either enter both dates or leave both fields empty.';
				}
			}
			if (vStartDate2 > vEndDate2) {
				vRptRun = 'This is not a valid period. Please check dates entered.';
			}
			vRptType = 'gen';
		}
		else if (pRptCode == 'WDT2') {
			vRptParams = 	document.getElementById('P333_WH_ID_844').value + "~" + 
							document.getElementById('P333_CLASSIFICATION_844').value + "~" +
							document.getElementById('P333_DATE_844').value + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'EQUIP_DETAILS') {
			vRptParams = 	$v('P333_PROFILE_ID') + "~" +
							$v('P333_OBJECT_ID_946') + "~" +
							$v('P333_DATE_FROM_946')+ "~" +
							$v('P333_DATE_TO_946') + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'PROJECT_MANHRS') {
			vRptParams = 	document.getElementById('P333_PROJECT_ID').value + "~" +
							document.getElementById('P333_DATE_FROM_283').value + "~" +
							document.getElementById('P333_DATE_TO_283').value + "~";
			vRptType = 'gen';
		}
		else if (pRptCode == 'PROJECT_OVERVIEW') {
			vRptParams = 	document.getElementById('P333_PROJECT_ID').value + "~" +
							document.getElementById('P333_TASK_ID').value + "~" +
							$v('P333_COMMENTS_202') + "~" +
							$v('P333_TASK_DESCRIPTION_202') + "~" +
							$v('P333_COMPLETION_202') + "~" +
							$v('P333_CHARGED_PLANNED_HRS_202') + "~" +
							$v('P333_START_DATE_DUR_202') + "~" +
							$v('P333_ASSIGNED_202') + "~";
			vRptType = 'gen';
		}		
		else if (pRptCode == 'CDT') {
			vDocId = document.getElementById('P333_DOC_ID').value;
			vProfileId = document.getElementById('P333_PROFILE_ID').value;
			vRptParams = 	vDocId + "~" +
							vProfileId + "~~";
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = document.getElementById('P333_REPORT_TITLE').value;
		}	
		else if (pRptCode == 'WDT') {
			vDocId = document.getElementById('P333_DOC_ID').value;
			vProfileId = document.getElementById('P333_PROFILE_ID').value;
			vRptParams = 	vDocId + "~" +
							vProfileId + "~";
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = document.getElementById('P333_REPORT_TITLE').value;
		}	
		else if (pRptCode == 'HR') {
			vDocId = document.getElementById('P333_DOC_ID').value;
			vProfileId = document.getElementById('P333_PROFILE_ID').value;
			vUserId = document.getElementById('P333_USER_ID').value;
			vRptParams = 	vDocId + "~" +
							vProfileId + "~"
							vUserId + "~";
			vRptTabPopup = 'TAB';
			vRptFilename = document.getElementById('P333_REPORT_NAME').value;
			vRptType = 'pdf';
			vRptTitlename = document.getElementById('P333_REPORT_TITLE').value;
		}
		else if (pRptCode == 'CONTACT_DIST_CALC') {
			vAddrIds = apex.item("P333_ADDR_IDS_1585").getValue();
			//vAddrIds = vAddrIds.join();
			//console.log(vAddrIds);
			vAddrIds = vAddrIds.replace(/:/g,';');
			//console.log(vAddrIds);
			vRptParams = 	$v('P333_TRAVEL_MODE_1585') 					+ "~" +
							$v('P333_OBJ_ID_1585') 							+ "~" +
							vAddrIds										+ "~";
			vRptType = 'gen';
		}
		//console.log("&APP_PROFILE_ID_FOL.");
		console.log("1-"+vRptCode+"-"+
			  vRptParams+"-"+
			  vRptType+"-"+
			  vRptFilename+"-"+
			  vRptTitlename+"-"+
			  vRptRun);
        
    },
	getID: function (pRptCode) {
		apex.server.process('reportID', {
			x01: pRptCode
		}, {
				type: "GET",
				dataType: "html",
				success: function (ret) {
					vRptID = ret;
				}
			});
    }
};

/* TODO cleanup after UT*/
var reportRun = lx.report.run2;